import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { EmbedIcon, FacebookIcon, LinkedInIcon, LinkIcon, WhatsAppIcon, XIcon } from '~/core/customIcons';

import ShareLinkPopper from './components/ShareLinkPopper';

import { LinkContainer, LinksContainer } from './styles';

type Props = {
    sharingUrl: string;
    title: string;
    embedString?: string;
};

const ShareBar: FC<Props> = ({ sharingUrl, title, embedString }) => {
    const intl = useIntl();

    return (
        <LinksContainer>
            <LinkContainer
                title={intl.formatMessage({
                    description: 'Describes an action that will share an item on Whatsapp',
                    defaultMessage: 'Share on Whatsapp',
                })}
                target="_blank"
                href={`https://api.whatsapp.com/send?text=${sharingUrl}`}
            >
                <WhatsAppIcon />
            </LinkContainer>
            <LinkContainer
                target="_blank"
                title={intl.formatMessage({
                    description: 'Describes an action that will share an item on Facebook',
                    defaultMessage: 'Share on Facebook',
                })}
                href={`https://www.facebook.com/sharer/sharer.php?u=${sharingUrl}`}
            >
                <FacebookIcon />
            </LinkContainer>
            <LinkContainer
                target="_blank"
                title={intl.formatMessage({
                    description: 'Describes an action that will share an item on X',
                    defaultMessage: 'Share on X',
                })}
                href={`https://twitter.com/intent/tweet?url=${sharingUrl}&text=${title}`}
            >
                <XIcon />
            </LinkContainer>
            <LinkContainer
                target="_blank"
                title={intl.formatMessage({
                    description: 'Describes an action that will share an item on LinkedIn',
                    defaultMessage: 'Share on LinkedIn',
                })}
                href={`https://www.linkedin.com/sharing/share-offsite/?url=${sharingUrl}`}
            >
                <LinkedInIcon />
            </LinkContainer>
            <ShareLinkPopper
                link={sharingUrl}
                title={intl.formatMessage({
                    description: "Describes an action that will copy a share URL to user's clipboard",
                    defaultMessage: 'Copy Link',
                })}
            >
                <LinkIcon />
            </ShareLinkPopper>
            {embedString && (
                <ShareLinkPopper
                    link={embedString}
                    title={intl.formatMessage({
                        description: "Describes an action that will copy an embed code to user's clipboard",
                        defaultMessage: 'Embed Video',
                    })}
                    popperText={intl.formatMessage({
                        description: 'A message indicating that a user has copied an embed link to their clipboard',
                        defaultMessage: 'Video Link Copied',
                    })}
                >
                    <EmbedIcon />
                </ShareLinkPopper>
            )}
        </LinksContainer>
    );
};

export default ShareBar;
